if (!customElements.get('fu-promotions-hub')) {
  customElements.define('fu-promotions-hub', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.select = this.querySelector('[data-offer-field]');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-fu-retry]')) return window.FUPromotions.refresh();
        const link = event.target.closest('[data-offer-select]');
        if (!link || !this.select) return;
        const option = [...this.select.options].find(item => item.dataset.offerKey === link.dataset.offerSelect);
        if (!option) return;
        this.select.value = option.value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        requestAnimationFrame(() => this.select.focus({ preventScroll: true }));
      }, { signal });
      this.unsubscribe?.();
      this.unsubscribe = window.FUPromotions.subscribe(state => this.renderOffers(state));
    }
    renderOffers(state) {
      if (!this.isConnected) return;
      this.querySelector('[data-fu-loading]').hidden = state.status !== 'loading';
      this.querySelector('[data-fu-load-error]').hidden = !['error', 'partial'].includes(state.status);
      this.querySelector('[data-fu-empty]').hidden = state.status !== 'ready' || state.records.length > 0;
      if (state.status === 'loading') return;
      if (this.lastRecords?.length === state.records.length && state.records.every((record, index) => record.template === this.lastRecords[index].template)) return;
      this.lastRecords = state.records;
      const selected = [...(this.select?.options || [])].find(option => option.selected)?.dataset.offerKey;
      const grid = this.querySelector('[data-fu-offer-grid]');
      const nav = this.querySelector('[data-fu-offer-nav]');
      grid.replaceChildren(); nav.replaceChildren();
      this.select?.querySelectorAll('[data-offer-key]').forEach(option => option.remove());
      const fragment = document.createDocumentFragment();
      state.records.forEach(record => {
        const card = record.template.content.querySelector('[data-fu-card]').firstElementChild.cloneNode(true);
        fragment.append(card);
        const link = document.createElement('a');
        link.href = `#fu-promotion-${record.handle}`; link.textContent = record.brand; nav.append(link);
        if (this.select) {
          const option = document.createElement('option');
          option.value = record.label; option.textContent = record.label; option.dataset.offerKey = record.handle;
          this.select.insertBefore(option, this.select.lastElementChild);
          if (selected === record.handle) option.selected = true;
        }
      });
      grid.append(fragment);
      if (selected && !state.records.some(record => record.handle === selected)) this.select.selectedIndex = 0;
      if (!this.didAnchor && location.hash.startsWith('#fu-promotion-')) {
        this.didAnchor = true;
        requestAnimationFrame(() => document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView({ block: 'start' }));
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribe?.(); }
  });
}
